import api from './api';

function cleanParams(params = {}) {
  const result = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }
    result[key] = value;
  });
  return result;
}

export async function getMonthlyReportTypes() {
  const { data } = await api.get('/monthly-reports/types');
  return data;
}

export async function getMonthlyReportCurrentStatus(params = {}) {
  const { data } = await api.get('/monthly-reports/status/current', {
    params: cleanParams(params),
  });
  return data;
}

export async function listMonthlyReports(params = {}) {
  const { data } = await api.get('/monthly-reports', {
    params: cleanParams(params),
  });
  return data;
}

export async function getMonthlyReportById(reportId) {
  const { data } = await api.get(`/monthly-reports/${reportId}`);
  return data;
}

export async function generateMonthlyReport(payload = {}) {
  const { data } = await api.post('/monthly-reports/generate', payload);
  return data;
}

export async function generateAllMonthlyReports(payload = {}) {
  const { data } = await api.post('/monthly-reports/generate-all', payload);
  return data;
}

export async function regenerateMonthlyReport(reportId, payload = {}) {
  const { data } = await api.post(`/monthly-reports/${reportId}/regenerate`, payload);
  return data;
}
